import React, { useEffect } from 'react';
import CategoryTabs from '../categoryTabs/CategoryTabs';

/**
 * TabBar - A wrapper around CategoryTabs for backward compatibility
 * This component now directly uses CategoryTabs with the same styling
 *
 * @param {Object} props
 * @param {Array} props.labels - Array of tab labels
 * @param {number} props.value - The currently active tab index
 * @param {function} props.onChange - Callback function when a tab is selected
 * @returns {JSX.Element}
 */
const TabBar = ({ labels, value, onChange }) => {
    const [currentIndex, setCurrentIndex] = React.useState(value || 0);

    // Update internal state when value prop changes
    useEffect(() => {
        if (value != undefined) {
            setCurrentIndex(value);
        }
    }, [value]);

    // Convert labels array to categories array format
    const categories = labels.map((label, index) => ({
        id: index,
        label: label
    }));

    const handleCategoryChange = (categoryId) => {
        setCurrentIndex(categoryId);
        onChange(categoryId);
    };

    return (
        <CategoryTabs
            categories={categories}
            activeCategory={currentIndex}
            onCategoryChange={handleCategoryChange}
        />
    );
};

export default TabBar;